// extracted by mini-css-extract-plugin
export default {"avatar":"style_avatar__PDwpk","emptyPhoto":"style_emptyPhoto__oLb0h","avatarSmall":"style_avatarSmall__7wrzB","avatarMedium":"style_avatarMedium__6RKJ7"};